import Link from 'next/link';

import clsx from 'clsx';
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';

import useTranslation from '@/utils/hooks/translation/useTranslation';
dayjs.extend(isBetween);

// Utils
import useSubscription from '@/utils/hooks/swr/pricing/useSubscription';
import useUserRole from '@/utils/hooks/user/useUserRole';

// Types
import type { ActivePlanType } from '@/types/pricingTypes/subscriptionType';

// Lib
import { SUBSCRIPTION_INVOICES } from '@/lib/routes/privateRoutes';

export function ReminderCancellationPlan() {
    const { t } = useTranslation('layout_platform');
    const { isAdmin } = useUserRole();

    const { subscription } = useSubscription();
    const isActive =
        subscription?.product_key !== 'trial' &&
        subscription?.is_waiting_for_cancel &&
        subscription?.next_renewal !== null &&
        dayjs().isBetween(
            dayjs(subscription?.next_renewal).subtract(31, 'day'),
            dayjs(subscription?.next_renewal)
        );

    if (!isActive) {
        return null;
    }

    const nextRenewal = (subscription as ActivePlanType)?.next_renewal;

    return (
        <div className="flex min-h-10 items-center justify-center gap-1 bg-icoRed-100 py-3 text-xs dark:bg-icoRed/20">
            {t(
                clsx({
                    'reminder_cancellation_plan.admin': isAdmin,
                    'reminder_cancellation_plan.team_member': !isAdmin
                }),
                { count: dayjs(nextRenewal).diff(dayjs(), 'day') }
            )}
            {isAdmin ? (
                <Link href={SUBSCRIPTION_INVOICES} className="text-icoRed underline">
                    {t('reminder_cancellation_plan.button_resubscribe')}
                </Link>
            ) : null}
        </div>
    );
}
